import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import GridWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/GridWrapper"
import SliderWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/SliderWrapper"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/sharp-light-svg-icons"

import VariantCard from "../molecules/VariantCard"

import { useTranslation } from "react-i18next"

const VariantCardsBlock = ({ block }) => {
  const { t } = useTranslation()
  let view = block.view?.length > 0 ? block.view : "slider"
  let showSlides =
    block.show_slides && block.show_slides !== "" ? block.show_slides : 4

  if (view === "grid") {
    return (
      <BlockWrapper block={block} blockWidth="container" showHeadline="false">
        <div
          id="variants"
          className="flex flex-row items-baseline justify-between pb-10"
        >
          <Headline
            headline={t("generic.products.choose_a_variant")}
            headlineLevel="h4"
            tagName="h2"
          />

          {block.link_text && (
            <Link className="ml-4" link={block.link}>
              {block.link_text}
              <FontAwesomeIcon
                icon={faArrowRight}
                size="1x"
                className="inline-block ml-2 -mt-0.5 align-middle"
              />
            </Link>
          )}
        </div>
        <GridWrapper showSlides={showSlides}>
          {block.variant_items?.length > 0 &&
            block.variant_items.map((item, index) => (
              <div
                className="w-full px-grid lg:w-1/4 focus:outline-none"
                key={index}
              >
                <VariantCard item={item} />
              </div>
            ))}
        </GridWrapper>
      </BlockWrapper>
    )
  } else {
    return (
      <BlockWrapper block={block} blockWidth="container" showHeadline="false">
        <div
          id="variants"
          className="flex flex-row items-baseline justify-between pb-10"
        >
          <Headline
            headline={t("generic.products.choose_a_variant")}
            headlineLevel="h4"
            tagName="h2"
          />
          {block.link_text && (
            <Link className="ml-4" link={block.link}>
              {block.link_text}
              <FontAwesomeIcon
                icon={faArrowRight}
                size="1x"
                className="inline-block ml-2 -mt-0.5 align-middle"
              />
            </Link>
          )}
        </div>
        <SliderWrapper uid={block._uid} showSlides={showSlides}>
          {block.variant_items?.length > 0 &&
            block.variant_items.map((item, index) => (
              <div className="w-full px-grid" key={index}>
                <VariantCard item={item} />
              </div>
            ))}
        </SliderWrapper>
      </BlockWrapper>
    )
  }
}

export default VariantCardsBlock
